// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"27d4b916","207":"0af1e1af","608":"38c07cc7","687":"6991cd54","742":"db6842cd","846":"d6434ec5"}[chunkId] + ".chunk.css";
};